import React, { Component } from "react";
import { Card, Row, Col, Tooltip } from "antd";
import { Fragment } from "react";
import moment from "moment";
import UpArrow from "../../images/UpArrow.svg"
import DownArrow from "../../images/DownArrow.svg";
import CollapsibleServiceData from "./CollapsibleServiceData"

export default class PaymentTableData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      direction: "down",
      selIndex: null,
      adjustmentDetails: [],
      componentKey: 1,
    };
  }

  componentDidMount() {
    this.setState({
      adjustmentDetails: this.props.serviceInformation.adjustmentDetails ? this.props.serviceInformation.adjustmentDetails : []
    })
  }

  toggleView = (type, index) => {
    this.setState({
      componentKey: ++this.state.componentKey,
      direction: type,
      selIndex: index
    })
  }

  itemOpened = (index) => {
    return (this.state.direction === "up" && this.state.selIndex === index)
  }

  render() {
    const serviceInformation = this.props.serviceInformation;
    return (
      <Fragment>
        {serviceInformation && serviceInformation.map((service, index) => (
          <Row className={`pt-2 services-row ${this.state.direction === "up" && this.state.selIndex === index ? "highlightService" : "servicesRow"}`}>
            <Col span={1} className="pl-2 pb-2">
              {index >= 9 ? index + 1 : "0" + (index + 1)}
            </Col>
            <Col span={1} className="pr-1 pb-2">
              {service.procedureCode ? service.procedureCode : "-"}
            </Col>
            <Col span={2} className="pr-1 pb-2">
              {service.fromDos ? moment(new Date(service.fromDos)).format("ll") : "-"}
            </Col>
            <Col span={2} className="pr-1 pb-2">
              {service.toDos ? moment(new Date(service.toDos)).format("ll") : "-"}
            </Col>
            <Col span={1} className="pr-1 pb-2">
              {service.pos ? service.pos : "-"}
            </Col>
            {/* <Col span={3} className="pb-2 px-3" style={{ textAlign: "center" }}>
              <Row>
                <Col span={6} className="">
                  {service.modifier1 ? service.modifier1 : "-"}
                </Col>
                <Col span={6} className="">
                  {service.modifier2 ? service.modifier2 : "-"}
                </Col>
                <Col span={6} className="">
                  {service.modifier3 ? service.modifier3 : "-"}
                </Col>
                <Col span={6}>
                  {service.modifier4 ? service.modifier4 : "-"}
                </Col>
              </Row>
            </Col> */}

            <Col span={3} className=" px-3 pb-2" style={{ textAlign: "center" }}>
              {/* <span>Diagnosis Points</span> */}
              <Row justify="center">
                <Col span={6} className="">
                  {service.diagnosisCodePointer1 ? service.diagnosisCodePointer1 : "-"}
                </Col>
                <Col span={6} className="">
                  {service.diagnosisCodePointer2 ? service.diagnosisCodePointer2 : "-"}
                </Col>
                <Col span={6} className="">
                  {service.diagnosisCodePointer3 ? service.diagnosisCodePointer3 : "-"}
                </Col>
                <Col span={6}>
                  {service.diagnosisCodePointer4 ? service.diagnosisCodePointer4 : "-"}
                </Col>
              </Row>
            </Col>
            <Col span={1} className="pr-1 pb-2">
              {service.unit ? service.unit : "-"}
            </Col>
            <Col span={2} className="pr-1 pb-2">
              {service.unitCount ? service.unitCount : "-"}
            </Col>
            <Col span={1} className=" pb-2">
              {service.adjustmentDetails && service.adjustmentDetails.length > 0 ? '$' + parseFloat(service.adjustmentDetails[0].totalCopayAmount).toFixed(2) : "-"}
            </Col>
            <Col span={1} className=" pb-2">
              {service.adjustmentDetails && service.adjustmentDetails.length > 0 ? '$' + parseFloat(service.adjustmentDetails[0].totalCoInsuranceAmount).toFixed(2) : "-"}
            </Col>
            <Col span={2} className="pr-1 pb-2">
              {service.totalCharge ? '$' + parseFloat(service.totalCharge).toFixed(2) : "-"}
            </Col>
            <Col span={2} className="pr-1 pb-2">
              {service.adjudicationStatus ? service.adjudicationStatus : "-"}
            </Col>
            <Col span={2} className="pr-1 pb-2">
              {service.serviceStatus ? service.serviceStatus : "-"}
            </Col>
            <Col className="pr-1 pb-2">
            
              {/* <div 
              // onClick={() => this.toggleView(this.itemOpened(index) ? "down" : "up", index)}
              > */}
              <span 
              onClick={() => this.toggleView(this.itemOpened(index) ? "down" : "up", index)}
              style={{ color: `${this.itemOpened(index) ? "" : "#4B84E8"}`, cursor: "pointer"}}
              >
                {this.itemOpened(index) ? "Hide Info." : "More Info." }
              
                {this.itemOpened(index) && 
                  <img
                    src={UpArrow}
                    alt="Up Arrow"
                    width="10px"
                    className="ml-2"
                    id="image1"
                  />}
                  {!this.itemOpened(index) && <img
                    // onClick={() => this.toggleView("up", index)}
                    src={DownArrow}
                    alt="Down Arrow"
                    width="10px"
                    className="ml-2"
                    id="image2"
                  />}
                  </span>
              {/* </div> */}
            </Col>

            {this.state.direction === "up" && this.state.selIndex === index && 
            <CollapsibleServiceData 
              direction={this.state.direction}
              selIndex={this.state.selIndex}
              service={service ? service : {}}
              // key={this.state.componentKey}
            />}
          </Row>
        ))
        }
      </Fragment>
    );
  }
}
